import { render, staticRenderFns } from "./ProspectAdmin.vue?vue&type=template&id=7465215d&scoped=true&"
import script from "./ProspectAdmin.vue?vue&type=script&lang=js&"
export * from "./ProspectAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProspectAdmin.vue?vue&type=style&index=0&id=7465215d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7465215d",
  null
  
)

export default component.exports